"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckCircleIcon = exports.ToggleButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = __importDefault(require("@kyruus/button"));
const ui_theme_1 = require("@kyruus/ui-theme");
const CheckCircle_1 = __importDefault(require("@kyruus/react-ikons/CheckCircle"));
const success = (0, ui_theme_1.fromTheme)('color_success');
const successContrast = (0, ui_theme_1.fromTheme)('color_contrast_green_hover');
const primary = (0, ui_theme_1.fromTheme)('color_button');
const primaryContrast = (0, ui_theme_1.fromTheme)('color_button_contrast');
const primaryDisabled = (0, ui_theme_1.fromTheme)('color_button_disabled');
const textContrast = (0, ui_theme_1.fromTheme)('color_text_contrast');
exports.ToggleButton = (0, styled_1.default)(button_1.default) `
  background-color: ${({ isReferred }) => (isReferred ? success : 'inherit')};
  border-color: ${({ isReferred }) => (isReferred ? success : primary)};
  color: ${({ isReferred }) => (isReferred ? textContrast : primary)};
  &:hover {
    background-color: ${({ isReferred }) => isReferred ? successContrast : primaryContrast};
    border-color: ${({ isReferred }) => isReferred ? success : primaryContrast};
    color: ${textContrast};
  }
  &:focus {
    background-color: ${({ isReferred }) => isReferred ? successContrast : primaryContrast};
    border-color: ${({ isReferred }) => isReferred ? successContrast : primaryContrast};
    color: ${textContrast};
  }
  &:disabled {
    background-color: ${primaryDisabled};
    border-color: ${primaryDisabled};
    color: ${textContrast};
  }
`;
exports.CheckCircleIcon = (0, styled_1.default)(CheckCircle_1.default) `
  margin-left: 5px;
`;
//# sourceMappingURL=ProviderReferralButton.styles.js.map